<template>
    <div>
      <div class="text-center m-0 d-flex mt-5">
        <!-- Video element replaced with iframe for YouTube -->
        <div ref="player" id="player" style="max-width:1000px;border-radius: 16px; border: 10px solid #fff; background: rgba(255, 255, 255, 0.90);" height="500px"></div>
  
        <img ref="processedFrame" :src="processedFrameSrc" alt="Processed frame will appear here" class="" style="max-width:1000px;border-radius: 16px; border: 10px solid #fff; background: rgba(255, 255, 255, 0.90);" height="500px"/>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "YoloV8ObjectDetection",
    data() {
      return {
        processedFrameSrc: "data:image/jpeg;base64,", // Initial empty image source
      };
    },
    mounted() {
      this.loadYouTubeAPI();
    },
    beforeDestroy() {
      clearInterval(this.frameInterval);
    },
    methods: {
      loadYouTubeAPI() {
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  
        window.onYouTubeIframeAPIReady = this.initializePlayer;
      },
      initializePlayer() {
        this.player = new YT.Player(this.$refs.player, {
          height: '500',
          width: '1000',
          videoId: 'z1PGJ9quPV8',
          events: {
            'onReady': this.onPlayerReady,
            'onStateChange': this.onPlayerStateChange
          }
        });
      },
      onPlayerReady(event) {
        event.target.playVideo();
        this.frameInterval = setInterval(this.captureFrame, 200);
      },
      onPlayerStateChange(event) {
        if (event.data === YT.PlayerState.ENDED) {
          clearInterval(this.frameInterval);
        }
      },
      captureFrame() {
        const videoElement = document.getElementById('player').querySelector('iframe');
  
        if (!videoElement) return;
  
        const canvas = document.createElement('canvas');
        canvas.width = videoElement.clientWidth;
        canvas.height = videoElement.clientHeight;
        const context = canvas.getContext('2d');
        context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
  
        canvas.toBlob((blob) => {
          const formData = new FormData();
          formData.append('file', blob, 'frame.jpg');
  
          // Send the frame to the server
          fetch('https://devai.mywire.org' + '/idx_process_frame', {
            method: 'POST',
            body: formData,
          })
            .then((response) => response.blob())
            .then((blob) => {
              const url = URL.createObjectURL(blob);
              this.processedFrameSrc = url; // Update the processed image source
            })
            .catch((error) => {
              console.error("Error sending frame:", error);
            });
        }, 'image/jpeg');
      }
    }
  };
  </script>
  
  <style scoped>
  /* You can add custom styles here if needed */
  h1 {
    text-align: center;
    margin-top: 20px;
  }
  
  #player {
    display: block;
    margin: 20px auto;
  }
  
  img {
    display: block;
    margin: 20px auto;
    max-width: 100%;
  }
  </style>
  